var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 10.4998L23.3333 10.4998M9.33333 10.4998V23.3332M7.23333 23.3332H20.7667C22.0735 23.3332 22.7269 23.3332 23.226 23.0789C23.665 22.8551 24.022 22.4982 24.2457 22.0591C24.5 21.56 24.5 20.9066 24.5 19.5998V8.39984C24.5 7.09305 24.5 6.43965 24.2457 5.94053C24.022 5.50148 23.665 5.14453 23.226 4.92082C22.7269 4.6665 22.0735 4.6665 20.7667 4.6665L7.23333 4.6665C5.92654 4.6665 5.27315 4.6665 4.77402 4.92082C4.33498 5.14453 3.97802 5.50148 3.75432 5.94053C3.5 6.43965 3.5 7.09305 3.5 8.39984L3.5 19.5998C3.5 20.9066 3.5 21.56 3.75432 22.0591C3.97802 22.4982 4.33498 22.8551 4.77402 23.0789C5.27315 23.3332 5.92654 23.3332 7.23333 23.3332Z",
    stroke: "#C4C3FA",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLayout);
export default __webpack_public_path__ + "static/media/table-layout.b5eed99e6bbff93cd486d6cb8929f453.svg";
export { ForwardRef as ReactComponent };